import { render, staticRenderFns } from "./DetailList.vue?vue&type=template&id=47765162&scoped=true&"
import script from "./DetailList.vue?vue&type=script&lang=ts&"
export * from "./DetailList.vue?vue&type=script&lang=ts&"
import style0 from "./DetailList.vue?vue&type=style&index=0&id=47765162&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47765162",
  null
  
)

export default component.exports